import React from 'react';

import { bemCssModules, getTestId } from '@utils';

import AppButtons from './AppButtons';

import style from './Footer.scss';

const cn = bemCssModules(style, 'Footer');
const ti = getTestId('Footer');

const links = [
  { key: 'LinkedIn', url: 'https://www.linkedin.com/company/mercuryo-io' },
  { key: 'Twitter', url: 'https://twitter.com/Mercuryo_io' },
  { key: 'Facebook', url: 'https://www.facebook.com/mercuryo.io' },
];

const Footer: CustomFC = ({ className }) => (
  <div className={cn(null, [className])} data-testid={ti()}>
    <div className={cn('links')}>
      {links.map(({ key, url }) => (
        <a
          className={cn('link', ['link'])}
          key={key}
          href={url}
          target="_blank"
          rel="noreferrer"
          data-test-id={`${key}-link`}
        >
          {key}
        </a>
      ))}
    </div>
    <AppButtons className={cn('buttons')} />
  </div>
);

export default Footer;
